module.exports = __webpack_public_path__ + "img/CS-Small_Overview.c03cd876.jpg";